module.exports = __webpack_public_path__ + "static/img/question1.c25b618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question1.png
// module id = M1pF
// module chunks = 6